import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, HostListener, Inject, OnInit, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'minimal-navbar-component',
  templateUrl: './minimal-navbar.component.html',
  styleUrls: ['./minimal-navbar.component.scss','../navbar.component.scss']
})
export class MinimalNavbarComponent implements OnInit {
  constructor(@Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document) { }
  public fixNavBar: boolean = false;
  protected navbar = this.document.getElementById("navbar");
  protected sticky = this.navbar?.offsetTop;

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.stickyNavbar();
    }
  }

  @HostListener('window:scroll',['$event'])
  stickyNavbar() {
    let navbar = this.navbar;
    let sticky = this.sticky;
    if (!navbar||!sticky) return;
    isPlatformBrowser(this.platformId)&&window.scrollY >= sticky?this.fixNavBar = true:this.fixNavBar = false;
  }
}
